var map = {
	"./shopeeLogo.svg": 91186,
	"./shopeePayLogo.svg": 94798,
	"./shopeePayLogo2022.svg": 48348,
	"./shopeePayLogoMobile2022.svg": 58230,
	"Common/Assets/Icons/ShopeeLogo/shopeeLogo.svg": 91186,
	"Common/Assets/Icons/ShopeeLogo/shopeePayLogo.svg": 94798,
	"Common/Assets/Icons/ShopeeLogo/shopeePayLogo2022.svg": 48348,
	"Common/Assets/Icons/ShopeeLogo/shopeePayLogoMobile2022.svg": 58230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66228;